<template>
	<div class="download-file-list">
		<div v-for="(file, index) in fileList" :key="index" class="download-file-item">
			<a :href="baseUrl +'/files/'+file.downloadName">{{ file.displayName }}</a>
		</div>
	</div>
</template>

<script>
	import UploadService from "../../httpcommon/axioInstance.js";
	
	export default{
		name: "upload-files",
		props:{
			fileList:{}
		},
		data(){
			return{
				selectedFiles: undefined,
				fileServer:global.__fileServer,
				fileInfos: [],
			}/* end @return {type} */
		},/* end data(){} */
		computed:{
			baseUrl(){
				return window.location.origin;
			}
		},/* end computed:{} */
		methods:{
			
		},/* end methods:{} */
		mounted() {
			// UploadService.getFiles().then((response) => {
			// 	this.fileInfos = response.data;
			// });
		}/* end mounted(){} */
	}/* end export */
</script>

<style scoped>
	.download-file-list {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.download-file-item {
		padding: 12px 16px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		transition: border-color 0.3s;
	}

	.download-file-item:hover {
		border-color: var(--color-primary, #0066ff);
	}

	.download-file-item a {
		color: #333;
		font-size: 14px;
		text-decoration: none;
		transition: color 0.3s;
		display: block;
	}

	.download-file-item a:hover {
		color: var(--color-primary, #0066ff);
	}
</style>